import DashboardIcon from "../../assets/icons/DashboardIcon";
import ProgramsIcon from "../../assets/icons/ProgramsIcon";
import ReportsIcon from "../../assets/icons/ReportsIcon";
import ProfileIcon from "../../assets/icons/ProfileIcon";
import GearIcon from "../../assets/icons/GearIcon";
import RetestIcon from "../../assets/icons/RetestIcon";
import CompanyIcon from "../../assets/icons/CompanyIcon";
import ChecklistIcon from "../../assets/icons/ChecklistIcon";
import CommentIcon from "../../assets/icons/CommentIcon";
import NotificationIcon from "../../assets/icons/NotifcationIcon";

import { UserRole } from "../../utils/api/endpoints/user/credentials";
import MultipleUsersIcon from "../../assets/icons/MultipleUsersIcon";
import CashIcon from "../../assets/icons/CashIcon";
import DelegationIcon from "../../assets/icons/DelegationIcon";
import MonitorIcon from "../../assets/icons/MonitorIcon";
import { ReactNode } from "react";

export type BaseNavLink = {
  label: string;
  link: string;
  end?: boolean;
};

export type NavLinkProps = {
  icon: (props: { className?: string }) => any;
  default?: string;
  is_beta?: boolean;
  children?: NavLinkProps[];
} & BaseNavLink;

/**
 * Holds the side nav links and data
 * needed for the researcher dashboard
 */
export const researcherLinks: NavLinkProps[] = [
  {
    label: "Dashboard",
    icon: DashboardIcon,
    link: "/dashboard",
    end: true
  },
  {
    label: "Programs",
    icon: ProgramsIcon,
    link: "/dashboard/programs"
  },
  {
    label: "My Reports",
    icon: ReportsIcon,
    link: "/dashboard/reports"
  },
  {
    label: "Retests",
    icon: RetestIcon,
    link: "/dashboard/retests"
  },
  // {
  //   label: "Payments",
  //   icon: CashIcon,
  //   link: "/dashboard/payments"
  // },

  {
    label: "Settings",
    icon: GearIcon,
    link: "/dashboard/profile/edit/settings"
  }
];

/**
 * Holds the side nav links and data
 * needed for the business dashboard
 */
export const businessLinks: NavLinkProps[] = [
  {
    label: "Dashboard",
    icon: DashboardIcon,
    link: "/dashboard",
    end: true
  },
  {
    label: "Programs",
    icon: ProgramsIcon,
    link: "/dashboard/programs"
  },
  {
    label: "Assets",
    icon: MonitorIcon,
    link: "/dashboard/assets"
  },
  {
    label: "Subscription",
    icon: CashIcon,
    link: "/dashboard/subscription"
  },

  {
    label: "Reports",
    icon: ReportsIcon,
    link: "/dashboard/reports"
  },
  {
    label: "Retests",
    icon: RetestIcon,
    link: "/dashboard/retests"
  },
  {
    label: "Pentest Reports",
    icon: ReportsIcon,
    link: "/dashboard/pentest-reports"
  },
  {
    label: "Credential Vault",
    icon: GearIcon,
    link: "/dashboard/vault"
  },
  // {
  //   label: "Auto Reports",
  //   icon: RetestIcon,
  //   link: "/dashboard/automated-reports"
  // },
  // {
  //   label: "Multi Tenant",
  //   icon: MultipleUsersIcon,
  //   link: "/dashboard/invitation"
  // },
  // {
  //   label: "Patch Assistance",
  //   icon: PatchIcon,
  //   link: "/dashboard/assistant"
  // },
  // {
  //   label: "Payments",
  //   icon: CashIcon,
  //   link: "/dashboard/payments"
  // },

  {
    label: "Settings",
    icon: GearIcon,
    link: "/dashboard/settings"
  }


];

export const BusinessAdminLinks: NavLinkProps[] = [
  {
    label: "Dashboard",
    icon: DashboardIcon,
    link: "/dashboard",
    end: true
  },
  {
    label: "Programs",
    icon: ProgramsIcon,
    link: "/dashboard/programs"
  },
  {
    label: "Assets",
    icon: MonitorIcon,
    link: "/dashboard/assets"
  },
  {
    label: "Subscription",
    icon: CashIcon,
    link: "/dashboard/subscription"
  },

  {
    label: "Reports",
    icon: ReportsIcon,
    link: "/dashboard/reports"
  },
  {
    label: "Retests",
    icon: RetestIcon,
    link: "/dashboard/retests"
  },
  {
    label: "Credential Vault",
    icon: GearIcon,
    link: "/dashboard/vault"
  },
  // {
  //   label: "Multi Tenant",
  //   icon: MultipleUsersIcon,
  //   link: "/dashboard/invitation"
  // },
  // {
  //   label: "Patch Assistance",
  //   icon: PatchIcon,
  //   link: "/dashboard/assistant"
  // },
  // {
  //   label: "Payments",
  //   icon: CashIcon,
  //   link: "/dashboard/payments"
  // },

  {
    label: "Settings",
    icon: GearIcon,
    link: "/dashboard/settings"
  }


];

export const DeveloperLinks: NavLinkProps[] = [
  {
    label: "Dashboard",
    icon: DashboardIcon,
    link: "/dashboard",
    end: true
  },
  {
    label: "Reports",
    icon: ReportsIcon,
    link: "/dashboard/reports"
  },
  {
    label: "Assets",
    icon: MonitorIcon,
    link: "/dashboard/assets"
  },
  {
    label: "Retests",
    icon: RetestIcon,
    link: "/dashboard/retests"
  },
  // {
  //   label: "Invitation",
  //   icon: MultipleUsersIcon,
  //   link: "/dashboard/invitation"
  // },
  // {
  //   label: "Patch Assistance",
  //   icon: PatchIcon,
  //   link: "/dashboard/assistant"
  // },
  // {
  //   label: "Payments",
  //   icon: CashIcon,
  //   link: "/dashboard/payments"
  // },

  {
    label: "Settings",
    icon: GearIcon,
    link: "/dashboard/settings"
  }
];

export const BusinessManagerLinks: NavLinkProps[] = [
  {
    label: "Dashboard",
    icon: DashboardIcon,
    link: "/dashboard",
    end: true
  },
  {
    label: "Programs",
    icon: ProgramsIcon,
    link: "/dashboard/programs"
  },
  {
    label: "Assets",
    icon: MonitorIcon,
    link: "/dashboard/assets"
  },
  {
    label: "Credential Vault",
    icon: GearIcon,
    link: "/dashboard/vault"

  },
  // {
  //   label: "Reports",
  //   icon: ReportsIcon,
  //   link: "/dashboard/reports"
  // },
  // {
  //   label: "Retests",
  //   icon: RetestIcon,
  //   link: "/dashboard/retests"
  // },
  // {
  //   label: "Invitation",
  //   icon: MultipleUsersIcon,
  //   link: "/dashboard/invitation"
  // },
  // {
  //   label: "Patch Assistance",
  //   icon: PatchIcon,
  //   link: "/dashboard/assistant"
  // },
  // {
  //   label: "Payments",
  //   icon: CashIcon,
  //   link: "/dashboard/payments"
  // },

  {
    label: "Settings",
    icon: GearIcon,
    link: "/dashboard/settings"
  }


];

/**
 * Holds the properties for the nav links
 * needed for the admin dashboard
 */
export const adminLinks: NavLinkProps[] = [
  {
    label: "Dashboard",
    icon: DashboardIcon,
    link: "/dashboard",
    end: true
  },

  {
    label: "Companies",
    icon: CompanyIcon,
    link: "/dashboard/companies"
  },
  {
    label: "Reports",
    icon: ReportsIcon,
    link: "/dashboard/reports"
  },
  {
    label: "Retests",
    icon: RetestIcon,
    link: "/dashboard/retests"
  },
  {
    label: "Pentest Reports",
    icon: ReportsIcon,
    link: "/dashboard/pentest-reports"
  },
  {
    label: "Comments",
    icon: CommentIcon,
    link: "/dashboard/comments"
  },
  {
    label: "Checklists",
    icon: ChecklistIcon,
    link: "/dashboard/checklist-templates"
  },

  {
    label: "Users",
    icon: MultipleUsersIcon,
    link: "/dashboard/users",
    children: [
      {
        label: "Delegations",
        icon: DelegationIcon,
        link: "/dashboard/delegations"
      },
      {
        label: "Auto-Delegation",
        icon: MonitorIcon,
        link: "/dashboard/auto-delegation-monitor"
      }
    ]
  },
  // {
  //   label: "Multi Tenant",
  //   icon: MultipleUsersIcon,
  //   link: "/dashboard/invitation"
  // },
  // {
  //   label: "Payments",
  //   icon: CashIcon,
  //   link: "/dashboard/payments"
  // },
  // {
  //   label: "Auto Reports",
  //   icon: RetestIcon,
  //   link: "/dashboard/automated-reports"
  // },
  {
    label: "Settings",
    icon: GearIcon,
    link: "/dashboard/settings"
  }


];

export const subAdminLinks: NavLinkProps[] = [
  {
    label: "Dashboard",
    icon: DashboardIcon,
    link: "/dashboard",
    end: true
  },

  {
    label: "Companies",
    icon: CompanyIcon,
    link: "/dashboard/companies"
  },
  {
    label: "Reports",
    icon: ReportsIcon,
    link: "/dashboard/reports"
  },
  {
    label: "Retests",
    icon: RetestIcon,
    link: "/dashboard/retests"
  },
  {
    label: "Pentest Reports",
    icon: ReportsIcon,
    link: "/dashboard/pentest-reports"
  },
  {
    label: "Comments",
    icon: CommentIcon,
    link: "/dashboard/comments"
  },
  {
    label: "Checklists",
    icon: ChecklistIcon,
    link: "/dashboard/checklist-templates"
  },

  {
    label: "Users",
    icon: MultipleUsersIcon,
    link: "/dashboard/users",
    children: [
      {
        label: "Delegations",
        icon: DelegationIcon,
        link: "/dashboard/delegations"
      },
      {
        label: "Auto-Delegation",
        icon: MonitorIcon,
        link: "/dashboard/auto-delegation-monitor"
      }
    ]
  },
  // {
  //   label: "Auto Reports",
  //   icon: RetestIcon,
  //   link: "/dashboard/automated-reports"
  // },
  // {
  //   label: "Multi Tenant",
  //   icon: MultipleUsersIcon,
  //   link: "/dashboard/invitation"
  // },
  // {
  //   label: "Payments",
  //   icon: CashIcon,
  //   link: "/dashboard/payments"
  // },
  {
    label: "Settings",
    icon: GearIcon,
    link: "/dashboard/settings"
  }
];

export const adminManagerLinks: NavLinkProps[] = [
  {
    label: "Dashboard",
    icon: DashboardIcon,
    link: "/dashboard",
    end: true
  },
  {
    label: "Companies",
    icon: CompanyIcon,
    link: "/dashboard/companies"
  },
  // {
  //   label: "Reports",
  //   icon: ReportsIcon,
  //   link: "/dashboard/reports"
  // },
  // {
  //   label: "Retests",
  //   icon: RetestIcon,
  //   link: "/dashboard/retests"
  // },
  // {
  //   label: "Auto Reports",
  //   icon: RetestIcon,
  //   link: "/dashboard/automated-reports"
  // },

  {
    label: "Users",
    icon: MultipleUsersIcon,
    link: "/dashboard/users",
    children: [
      {
        label: "Delegations",
        icon: DelegationIcon,
        link: "/dashboard/delegations"
      }
    ]
  },

  // {
  //   label: "Multi Tenant",
  //   icon: MultipleUsersIcon,
  //   link: "/dashboard/invitation"
  // },
  // {
  //   label: "Payments",
  //   icon: CashIcon,
  //   link: "/dashboard/payments"
  // },
  {
    label: "Settings",
    icon: GearIcon,
    link: "/dashboard/settings"
  }
];

export const QaLinks: NavLinkProps[] = [
  {
    label: "Dashboard",
    icon: DashboardIcon,
    link: "/dashboard",
    end: true
  },
  {
    label: "Programs",
    icon: ProgramsIcon,
    link: "/dashboard/programs"
  },
  {
    label: "Reports",
    icon: ReportsIcon,
    link: "/dashboard/reports"
  },
  {
    label: "Retests",
    icon: RetestIcon,
    link: "/dashboard/retests"
  },
  {
    label: "Delegations",
    icon: MultipleUsersIcon,
    link: "/dashboard/delegations"
  },
  {
    label: "Pentest Reports",
    icon: ReportsIcon,
    link: "/dashboard/pentest-reports"
  },
  {
    label: "Comments",
    icon: CommentIcon,
    link: "/dashboard/comments"
  },
  {
    label: "Checklists",
    icon: ChecklistIcon,
    link: "/dashboard/checklist-review"
  },
  // {
  //   label: "Users",
  //   icon: MultipleUsersIcon,
  //   link: "/dashboard/users"
  // },
  // {
  //   label: "Multi Tenant",
  //   icon: MultipleUsersIcon,
  //   link: "/dashboard/invitation"
  // },
  // {
  //   label: "Payments",
  //   icon: CashIcon,
  //   link: "/dashboard/payments"
  // },
  {
    label: "Profile",
    icon: ProfileIcon,
    link: "/dashboard/profile"
  },
  {
    label: "Settings",
    icon: GearIcon,
    link: "/dashboard/settings"
  }
];

export const solutionsSpecialistLinks: NavLinkProps[] = [
  {
    label: "Main Dashboard",
    icon: DashboardIcon,
    link: "/dashboard/sales",
    end: true
  },
  {
    label: "Intakes",
    icon: ChecklistIcon,
    link: "/dashboard/sales/intakes"
  },
  {
    label: "Questionnaires",
    icon: ChecklistIcon,
    link: "/dashboard/sales/templates",
    end: true
  },
  {
    label: "Profile",
    icon: ProfileIcon,
    link: "/dashboard/profile"
  },
  {
    label: "Settings",
    icon: GearIcon,
    link: "/dashboard/settings"
  }
];

export const getUserLinks = (role: UserRole) => {
  let links: NavLinkProps[] = [];
  switch (role) {
    case UserRole.ADMIN:
      links = adminLinks;
      break;
    case UserRole.SUB_ADMIN:
      links = subAdminLinks;
      break;
    case UserRole.ADMIN_MANAGER:
      links = adminManagerLinks;
      break;
    case UserRole.QA:
      links = QaLinks;
      break;
    case UserRole.BUSINESS:
      links = businessLinks;
      break;
    case UserRole.DEVELOPER:
      links = DeveloperLinks;
      break;
    case UserRole.BUSINESS_MANAGER:
      links = BusinessManagerLinks;
      break;
    case UserRole.BUSINESS_ADMINISTRATOR:
      links = BusinessAdminLinks;
      break;
    case UserRole.RESEARCHER:
      links = researcherLinks;
      break;
    case UserRole.SOLUTIONS_SPECIALIST:
      links = solutionsSpecialistLinks;
      break;
    default:
      return [];
  }

  return links;
};
